import { Toaster } from "react-hot-toast";
import Layout from "../shared/Layout";
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import { useNavigate, useParams } from "react-router-dom";
import { API_URL, baseurl } from "../../_config";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import PlayersByTeamId from "./PlayersByTeamId";

const CricketTeam = () => {
    const navigate = useNavigate();
    const [teamsList, setTeamsList] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(false);
    const [activeTab, setActiveTab] = useState("team"); // ✅ Default tab is Team
    const params = useParams();
    const teamId = params?.id;
    const [playerByTeamData, setPlayerByTeamData] = useState([]);
    const [teamData, setTeamData] = useState([]);
    const [isFormopen, setIsFormopen] = useState(false);
    const fileInput = useRef(null);
    const [selectedTeamId, setSelectedTeamId] = useState(null);


    const fetchTeamsList = async () => {
        try {
            const response = await axios.get(`${baseurl}${API_URL.getTeams}`);
            if (response?.data.status === true) {
                setTeamsList(response?.data?.data)
            }
        } catch {
            return null;
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTeamsList();
    }, []);

    useEffect(() => {
        if (!teamId) {
            return;
        }
        const teamsById = async () => {
            try {
                const res = await axios.get(`${baseurl}${API_URL?.getTeams}?id=${teamId}`);

                if (res?.data.status === true) {
                    setTeamData(res?.data?.data[0])
                }

            } catch {
                setTeamData([])
            }
        }

        teamsById();

    }, [teamId]);


    useEffect(() => {
        const playerTeamsById = async () => {
            if (!teamId) {
                return;
            }
            try {
                const res = await axios.get(`${baseurl}${API_URL.getPlayersByTeamId}/${teamId}}`);

                if (res?.data?.status === true) {
                    setPlayerByTeamData(res?.data?.data)
                }

            } catch {
                setPlayerByTeamData([])
            }
        }

        playerTeamsById();

    }, [teamId])

    useEffect(() => {
        if (searchTerm) {
            const filtered = teamsList?.filter(item =>
                (item.teamName && item.teamName.toString().toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.captainName && item.captainName.toString().toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.captainMobile && item.captainMobile.toString().includes(searchTerm.toString()))
            );
            setFilteredData(filtered);
        } else {
            setFilteredData(teamsList);
        }
    }, [searchTerm, teamsList]);

    useEffect(() => {
        let data = teamsList;

        // ✅ Filter by active tab
        if (activeTab) {
            data = data.filter(item => item.type?.toLowerCase() === activeTab.toLowerCase());
        }

        // ✅ Search filter
        if (searchTerm) {
            data = data.filter(item =>
                (item.teamName && item.teamName.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.captainName && item.captainName.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (item.captainMobile && item.captainMobile.includes(searchTerm))
            );
        }

        setFilteredData(data);
    }, [searchTerm, teamsList, activeTab]);

    const handleDelete = async (teamId) => {
        const isConfirmed = window.confirm("Are you sure you want to delete this News?");

        if (isConfirmed) {
            try {
                const response = await axios.get(`${baseurl}${API_URL?.deleteTeam}?teamId=${teamId}`);

                if (response.data.status === true) {
                    toast.success("Deleted Successfully");
                    fetchTeamsList();
                } else {
                    toast.error("Deleted Failed!");
                }
            } catch (error) {
                toast.error("Please try again later.");
            }
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!selectedTeamId) {
            toast.error("Team ID not found!");
            return;
        }
        if (!fileInput.current?.files[0]) {
            toast.error("Please select an image");
            return;
        }

        const formData = new FormData();
        formData.append("teamId", selectedTeamId);
        formData.append("teamLogo", fileInput.current.files[0]);

        try {
            const response = await axios.post(
                `${baseurl}${API_URL.UpdateTeamLogo}`,
                formData,
                { headers: { "Content-Type": "multipart/form-data" } }
            );

            if (response.data.status === true) {
                toast.success("Team Logo Updated Successfully");
                setIsFormopen(false);
                fetchTeamsList();
            } else {
                toast.error("Update failed!");
            }
        } catch (error) {
            toast.error("Please try again later.");
        }
    };

    const columns = [
        {
            name: 'S.No',
            selector: (row, index) => index + 1,
            sortable: false,
            width: '60px',
        },
        {
            name: "Team Logo",
            selector: row =>
                row.teamLogo ? (
                    <img src={`${row.teamLogo}`} alt="icon" width="50" />
                ) : (
                    "No Image"
                ),
            minWidth: "150px"
        },
        {
            name: activeTab === "team" ? "Team Name" : "Role",
            selector: row => (
                <div>
                    {activeTab === "team" ? (
                        <Link to={`/cricket-teams/${row.id}`}>{row.teamName}</Link>
                    ) : (
                        <p>{row.teamName}</p>
                    )}
                </div>
            ),
            sortable: true,
            minWidth: '200px'
        },
        {
            name: activeTab === "team" ? "Captain Name" : "Player Name",
            selector: row => row.captainName,
            sortable: true,
            minWidth: '200px'
        },
        {
            name: 'Email Id',
            selector: row => (
                <div className="" >
                    <h6>{row.captainEmail}</h6>
                    <span>{row?.captainMobile}</span>
                </div>
            ),
            sortable: true,
            minWidth: '250px'
        },
        {
            name: 'City',
            selector: row => row.city,
            sortable: false,
            minWidth: '150px'

        },
        {
            name: 'State',
            selector: row => row.state,
            sortable: false,
            minWidth: '100px'

        },
        {
            name: 'Action',
            cell: row => (
                <div className="d-flex" style={{ gap: "10px" }}>
                    <span onClick={() => handleDelete(row?.id)} title='Delete' className="delete_icon_weepr">
                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 24 24">
                            <path d="M 10 2 L 9 3 L 4 3 L 4 5 L 5 5 L 5 20 C 5 20.522222 5.1913289 21.05461 5.5683594 21.431641 C 5.9453899 21.808671 6.4777778 22 7 22 L 17 22 C 17.522222 22 18.05461 21.808671 18.431641 21.431641 C 18.808671 21.05461 19 20.522222 19 20 L 19 5 L 20 5 L 20 3 L 15 3 L 14 2 L 10 2 z M 7 5 L 17 5 L 17 20 L 7 20 L 7 5 z M 9 7 L 9 18 L 11 18 L 11 7 L 9 7 z M 13 7 L 13 18 L 15 18 L 15 7 L 13 7 z" fill="#FF0000"></path>
                        </svg>
                    </span>
                </div>
            ),
            sortable: false
        },
        {
            name: "Add Logo",
            cell: row => (
                activeTab === "team" && (
                    <div className="add_team_logo">
                        <button
                            className=""
                            onClick={() => {
                                setSelectedTeamId(row.id);   // ⭐ SET TEAM ID
                                setIsFormopen(true);
                            }}
                        >
                            Add Logo
                        </button>
                    </div>
                )
            ),
            sortable: false,
            minWidth: "150px"
        },
    ];

    return (
        <Layout>
            <Toaster position="top-right" />
            <div className="right-content-section">
                <div className="admin-page mt-3 d-sm-flex justify-content-between align-items-center">
                    <div className="admin-heading">
                        {teamId ? (
                            <h4 className="mb-0 d-flex gap-3 align-items-center">
                                <button
                                    type="button"
                                    onClick={() => navigate(-1)}
                                    style={{
                                        border: "none",
                                        background: "transparent",
                                        cursor: "pointer",
                                        fontSize: "20px"
                                    }}
                                >
                                    <i className="fas fa-arrow-left"></i>
                                </button>
                                <p className="mb-0">{teamData?.teamName}</p>
                            </h4>
                        ) : (
                            <h4 className="mb-0">{activeTab === "team" ? "Team List" : "Individual Player List"}</h4>
                        )}
                    </div>
                    {!teamId && (
                        <div className="d-md-flex align-items-center justify-content-end gap-3">
                            <div className="search-container ">
                                <input
                                    type="text"
                                    placeholder="Search..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    className="form-control"
                                />
                            </div>
                        </div>
                    )}
                </div>

                {!teamId && (
                    <div className="d-flex gap-3 mt-3">
                        <button
                            className={`btn ${activeTab === "team" ? "btn-primary" : "btn-outline-primary"}`}
                            onClick={() => setActiveTab("team")}
                        >
                            Team
                        </button>
                        <button
                            className={`btn ${activeTab === "individual" ? "btn-primary" : "btn-outline-primary"}`}
                            onClick={() => setActiveTab("individual")}
                        >
                            Individual
                        </button>
                    </div>
                )}

                <div className="datatable mt-4">
                    {teamId ? (
                        <PlayersByTeamId playerByTeamData={playerByTeamData} loading={loading} />
                    ) : (
                        <DataTable
                            columns={columns}
                            data={filteredData || []}
                            progressPending={loading}
                            progressComponent={<p>Loading...</p>}
                            pagination
                            highlightOnHover
                        />
                    )}

                </div>
            </div>

            <div id="entryformContainer" className={`adminform entryform ${isFormopen ? 'open' : ''}`}>
                <div className="closebtn">
                    <button className="" onClick={() => setIsFormopen(false)}>
                        <svg clipRule="evenodd" fillRule="evenodd" height="30" imageRendering="optimizeQuality" shapeRendering="geometricPrecision" textRendering="geometricPrecision" viewBox="0 0 6.82666 6.82666" width="30" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" >
                            <g transform="matrix(1,0,0,1,0,0)">
                                <g id="Layer_x0020_1">
                                    <rect fill="#ffffff00" height="6.827" rx="1.507" width="6.827" stroke="none" />
                                    <path d="m2.21002 1.41333-.79669.79669 1.20331 1.20331-1.20331 1.20331.79669.79669 1.20331-1.20331 1.20332 1.20331.79668-.79669-1.2033-1.20331 1.2033-1.20331-.79669-.79669-1.20331 1.2033z" fill="#fffffe" stroke="none" />
                                </g>
                            </g>
                        </svg>
                    </button>
                </div>
                <div className="enForm">
                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label>Team Logo</label>
                            <input
                                type="file"
                                name="teamLogo"
                                ref={fileInput}
                                className="form-control"
                            />
                        </div>

                        <div className="d-flex form-buttons" style={{ gap: "15px" }}>
                            <div className="submit-btn pt-2">
                                <button type="submit">
                                    Submit
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </Layout>
    )
}

export default CricketTeam;